import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import i18next from 'i18next';

import useTypedSelector from 'hooks/useTypedSelector';
import { onGetOne } from 'redux/actions/marriages.actions';

import LayoutContainer from 'containers/LayoutContainer';
import MarriagesShow from 'views/public/MarriagesView/components/MarriagesShow';

import Loading from 'components/commons/Loading';

import 'views/public/MarriagesView/components/MarriagesShow/i18n';

const MarriagesShowContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { id = '' } = useParams<{ id?: string }>();
  const { loading, selectedItem: item } = useTypedSelector((state) => state.marriages);

  useEffect(() => {
    if (id) dispatch(onGetOne(id));
    return () => {
      dispatch(onGetOne(''));
    };
  }, [dispatch, id]);

  return (
    <LayoutContainer isPublic title={i18next.t<string>('PUBLIC_PROCEDURES_VIEW:TITLE')}>
      <MarriagesShow item={item} />
      {loading && <Loading isModalMode message={i18next.t('MARRIAGES_SHOW:LOADING')} />}
    </LayoutContainer>
  );
};

export default MarriagesShowContainer;
